import { render, staticRenderFns } from "./SelfTestPelletizingPelEdit.vue?vue&type=template&id=5d671465&"
import script from "./SelfTestPelletizingPelEdit.vue?vue&type=script&lang=js&"
export * from "./SelfTestPelletizingPelEdit.vue?vue&type=script&lang=js&"
import style0 from "./SelfTestPelletizingPelEdit.vue?vue&type=style&index=0&id=5d671465&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports